import { useEffect, useState } from 'react';

const deliverables = [
  {
    label: 'Architecture',
    body: 'System diagram. Data flow. Trust boundaries. Failure modes mapped before a line of code is written.',
  },
  {
    label: 'Credentials',
    body: 'API access, secret rotation policy, identity scopes. Documented. Reviewed. Auditable.',
  },
  {
    label: 'Test Cases',
    body: 'Edge cases enumerated. Acceptance criteria measurable. Regression safety baked in from day one.',
  },
];

export default function FeatureShuffler() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setI((v) => (v + 1) % deliverables.length), 3200);
    return () => clearInterval(id);
  }, []);
  const d = deliverables[i];

  return (
    <article className="grain group relative flex h-[420px] flex-col justify-between overflow-hidden rounded-4xl border border-white/10 bg-charcoal p-8">
      <div>
        <p className="label">Deliverable {i + 1} / {deliverables.length}</p>
        <h3 className="mt-6 font-display text-3xl font-light text-white">
          The Blueprint
        </h3>
      </div>

      <div className="relative h-32">
        {deliverables.map((item, idx) => (
          <div
            key={item.label}
            className={`absolute inset-0 transition-all duration-700 ${
              idx === i
                ? 'translate-y-0 opacity-100'
                : 'pointer-events-none translate-y-4 opacity-0'
            }`}
          >
            <p className="font-mono text-xs uppercase tracking-label text-gold">
              {item.label}
            </p>
            <p className="mt-2 font-sans text-body text-white/85">{d.body}</p>
          </div>
        ))}
      </div>

      <div className="flex items-center gap-2">
        {deliverables.map((_, idx) => (
          <span
            key={idx}
            className={`h-px transition-all duration-500 ${
              idx === i ? 'w-12 bg-gold' : 'w-6 bg-white/20'
            }`}
          />
        ))}
      </div>
    </article>
  );
}
